(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pairing-finder"] && !Shopify.designMode) return;
  try {
    
  class PairingFinder extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-pairing-grid]');
      this.prompt = this.querySelector('[data-pairing-prompt]');
      this.loading = this.querySelector('[data-pairing-loading]');
      this.header = this.querySelector('[data-pairing-results-header]');
      this.resultsTitle = this.querySelector('[data-pairing-results-title]');
      this.count = this.querySelector('[data-pairing-count]');
      this.empty = this.querySelector('[data-pairing-empty]');
      this.buttons = [...this.querySelectorAll('[data-pairing-choice]')];
      this.cards = [...this.querySelectorAll('[data-pairing-product]')];
      this.loadPromise = this.loadRemainingProducts();

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.selectPairing(button));
      });
    }

    async loadRemainingProducts() {
      const totalPages = Number(this.dataset.totalPages || 1);
      if (totalPages < 2) return;

      const sectionId = this.dataset.pairingSection;
      const requests = [];

      for (let pageNumber = 2; pageNumber <= totalPages; pageNumber += 1) {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', sectionId);
        url.searchParams.set('page', String(pageNumber));
        requests.push(fetch(url).then((response) => {
          if (!response.ok) throw new Error('Unable to load products');
          return response.text();
        }));
      }

      const pages = await Promise.all(requests);
      const parser = new DOMParser();

      pages.forEach((html) => {
        const documentPage = parser.parseFromString(html, 'text/html');
        documentPage.querySelectorAll('[data-pairing-product]').forEach((card) => {
          this.grid.append(card);
        });
      });

      this.cards = [...this.querySelectorAll('[data-pairing-product]')];
    }

    async selectPairing(button) {
      this.buttons.forEach((choice) => choice.setAttribute('aria-pressed', String(choice === button)));
      this.prompt.hidden = true;
      this.loading.hidden = false;

      try {
        await this.loadPromise;
      } catch (error) {
        this.loading.textContent = 'Une partie de la sélection n’a pas pu être chargée.';
      }

      const selectedId = button.dataset.pairingId;
      const matchingCards = this.cards.filter((card) => card.dataset.pairings.split('|').includes(selectedId));

      this.cards.forEach((card) => {
        card.hidden = !matchingCards.includes(card);
      });

      this.resultsTitle.textContent = button.dataset.pairingTitle;
      this.count.textContent = `${matchingCards.length} ${matchingCards.length > 1 ? 'vins sélectionnés' : 'vin sélectionné'}`;
      this.loading.hidden = true;
      this.header.hidden = false;
      this.grid.hidden = matchingCards.length === 0;
      this.empty.hidden = matchingCards.length !== 0;
      this.resultsTitle.focus({ preventScroll: true });
      this.header.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  if (!customElements.get('pairing-finder')) {
    customElements.define('pairing-finder', PairingFinder);
  }

  } catch(e) { console.error(e); }
})();
})();
